import React, { useState } from 'react';
import { Box, Button, Menu, Typography, RadioGroup, FormControlLabel, Radio, CircularProgress } from '@mui/material';
import styles from './orderbody.module.css';
import ReviewPopup from '../reviewpopup/ReviewPopup';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { formatedate } from '../../../helper/utils';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const Orderbody = ({ sort, setSort }) => {

    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const { orders, isLoading, pagination } = useSelector(state => state.orders);

    const navigate = useNavigate();

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const sortingOptions = [
        { name: 'newest', label: 'Newest First' },
        { name: 'oldest', label: 'Oldest First' }
    ];

    const handleClick = (e) => {
        setAnchorEl(e.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleSortChange = (e) => {
        setSort(e.target.value);
        handleClose();
    };

    if (isLoading) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 20, width: '80%' }}>
                <CircularProgress />
            </div>
        )
    }

    return (
        <div className={styles.profilebodyContainer}>
            <div className={styles.profileheader}>
                <h2>Orders</h2>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <Button
                        variant="outlined"
                        endIcon={<KeyboardArrowDownIcon />}
                        onClick={handleClick}
                        sx={{
                            textTransform: "none",
                            fontWeight: "bold",
                            color: "#000",
                            borderColor: "#ddd",
                            backgroundColor: "#fff",
                            minWidth: '160px',
                        }}
                    >
                        {sortingOptions.find((o) => o.name === sort)?.label}
                    </Button>
                    <Menu
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                        transformOrigin={{ vertical: "top", horizontal: "center" }}
                        PaperProps={{
                            sx: {
                                borderRadius: "8px",
                                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                                p: 2,
                                minWidth: "200px",
                                marginLeft: "-20px",
                            },
                        }}
                    >
                        <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ fontWeight: "bold", mb: 1 }}
                        >
                            SORT BY
                        </Typography>
                        <RadioGroup value={sort} onChange={handleSortChange}>
                            {sortingOptions.map((option) => (
                                <FormControlLabel
                                    key={option.name}
                                    value={option.name}
                                    control={<Radio />}
                                    label={option.label}
                                    sx={{
                                        '&.MuiFormControlLabel-root': {
                                            py: 0.5
                                        }
                                    }}
                                />
                            ))}
                        </RadioGroup>
                    </Menu>
                </Box>
            </div>

            <div className={styles.profilebodyContent}>
                {orders?.length > 0 ?
                    <>
                        {orders?.map((i, index) => {
                            return (
                                <div className={styles.container} key={i?._id} onClick={() => navigate(`/orderDetails/${i._id}`)} style={{ cursor: 'pointer' }}>
                                    <div style={{
                                        display: 'flex', gap: '20px', alignItems: 'center',
                                    }}>
                                        {i?.products?.length > 0 &&
                                            <img
                                                src={i?.products[0]?.productId?.featurerdImage}
                                                className={styles.productImage}
                                            />
                                        }
                                        <div style={{
                                            display: 'flex', gap: '10px',
                                            alignItems: 'flex-start',
                                            flexDirection: 'column'
                                        }}>
                                            <Box
                                                sx={{
                                                    backgroundColor: '#000',
                                                    color: '#fff',
                                                    borderRadius: '25px',
                                                    fontSize: { xs: '10px', sm: '12px', md: '14px' },
                                                    padding: { xs: '4px 8px', sm: '6px 10px' },
                                                    display: 'inline-block'
                                                }}
                                            >
                                                {i?.products?.[0]?.orderType}
                                            </Box>

                                            <Box>
                                                <Typography
                                                    sx={{
                                                        color: '#000000',
                                                        fontSize: { xs: '14px', sm: '16px' },
                                                        fontWeight: 500
                                                    }}
                                                >
                                                    {i?.products[0]?.productId?.productName}
                                                </Typography>

                                                {i?.products?.length > 1 && (
                                                    <Typography
                                                        sx={{
                                                            color: '#000000',
                                                            fontSize: { xs: '12px', sm: '14px' },
                                                        }}
                                                    >
                                                        +{i?.products?.length - 1} products
                                                    </Typography>
                                                )}

                                                <Box sx={{
                                                    display: 'flex',
                                                    flexDirection: { xs: 'column', sm: 'row' },
                                                    gap: '8px',
                                                    alignItems: { xs: 'flex-start', sm: 'center' },
                                                    marginTop: 1
                                                }}>
                                                    <Typography
                                                        sx={{
                                                            color: '#000000',
                                                            fontSize: { xs: '14px', sm: '14px' },
                                                            fontWeight: 600
                                                        }}
                                                    >
                                                        ₹ {i?.grandTotal?.toLocaleString("en-IN")}
                                                    </Typography>

                                                    {i?.discount !== 0 && (
                                                        <Typography
                                                            sx={{
                                                                textDecoration: 'line-through',
                                                                color: 'gray',
                                                                fontSize: { xs: '12px', sm: '14px' },
                                                            }}
                                                        >
                                                            ₹ {(i?.total + i?.discount)?.toLocaleString("en-IN")}
                                                        </Typography>
                                                    )}
                                                </Box>
                                            </Box>
                                        </div>
                                    </div>

                                    <div style={{
                                        display: 'flex', gap: '10px',
                                        alignItems: 'flex-start',
                                        justifyContent: 'space-around',
                                        flexDirection: 'column'
                                    }}>
                                        <Typography style={{
                                            color: '#000000',
                                            fontSize: '16px',
                                        }}>
                                            {formatedate(i?.createdAt)}
                                        </Typography>
                                    </div>
                                </div>
                            )
                        })
                        }
                    </>
                    :
                    <div>No Orders Found</div>
                }
                {isPopupVisible && (
                    <ReviewPopup onClose={() => setIsPopupVisible(false)} />
                )}
            </div>

        </div >
    )
}

export default Orderbody